import React, { FC, useEffect, useState } from "react";
import { Element } from "../../../models/elementModel";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import produce from "immer";
import { uuid } from "uuidv4";
import imageService from "../../../services/imageService";
import { defaultImg } from "../../../utils/constants";

export interface CarouselElementPropertiesProps {
  element: Element;
}

const CarouselElementProperties: FC<CarouselElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  const [addImage, setAddImage] = useState(0);
  const [images, setImages] = useState<JSX.Element[]>([]);

  useEffect(() => {
    fetchAndDisplayCarouselImages();
  }, [addImage]);

  // const addNewImage = (numImages: number) => {
  //   const newImageElements = [];

  //   for (let i = 1; i <= numImages; i++) {
  //     newImageElements.push(
  //       <div key={uuid()} className="col-sm-8">
  //         <input type="file" accept="image/*" onChange={onChange} />
  //       </div>
  //     );
  //   }
  //   return newImageElements;
  // };

  // const handleAddImageClick = () => {
  //   setAddImage(addImage + 1);
  // };

  // const handleRemoveImageClick = () => {
  //   setAddImage(addImage - 1);
  // };

  // const disablePlusButton = () => addImage >= 5;

  // const disableMinusButton = () => addImage <= 1;

  // const addNewImage = (numImages: number) => {
  //   const imageElements = [];
  //   for (let i = 1; i <= numImages; i++) {
  //     imageElements.push(
  //       <div key={uuid()} className="">
  //         {/* <div className="form-group row">
  //           <label
  //             htmlFor="link"
  //             className="col-sm-4 col-form-label font-size-12 align-text-left"
  //           >
  //             Link
  //           </label>
  //           <div className="col-sm-8">
  //             <textarea
  //               className="form-control theam-textbox font-size-12 items-align-left"
  //               name="link"
  //               id="link"
  //               placeholder="Enter Alredy Uploaded Image Link"
  //               cols={30}
  //               rows={2}
  //               value={element.properties.imageUrl}
  //               onChange={(e) => {
  //                 const newElement = produce(element, (draft) => {
  //                   draft.properties.imageUrl = e.target.value;
  //                 });
  //                 dispatch(startEditElement(newElement));
  //               }}
  //             ></textarea>
  //           </div>
  //         </div> */}

  //         <ImageUploading
  //           // multiple
  //           maxFileSize={5242880}
  //           value={images}
  //           onChange={onChange}
  //           // maxNumber={maxNumber}
  //           dataURLKey="data_url"
  //         >
  //           {({
  //             imageList,
  //             onImageUpload,
  //             onImageRemoveAll,
  //             onImageUpdate,
  //             onImageRemove,
  //             isDragging,
  //             dragProps,
  //           }) => (
  //             <div className="upload__image-wrapper">
  //               <div className="form-group row">
  //                 <div className="col-12">
  //                   <button
  //                     className="btn btn-dark btn-theam btn-lg btn-block ml-3 font-size-12"
  //                     style={isDragging ? { color: "red" } : undefined}
  //                     onClick={onImageUpload}
  //                     {...dragProps}
  //                   >
  //                     Click or Drop here{" "}
  //                   </button>
  //                 </div>
  //               </div>
  //               &nbsp;
  //               <div key={element.properties.id} className="image-item mb-2">
  //                 {/* <img src={element.properties.imageUrl} alt="" width="100" /> */}
  //                 <img
  //                   src={element.properties.imageUrl}
  //                   alt=""
  //                   width="100"
  //                   height="100"
  //                 />
  //               </div>
  //               &nbsp;
  //               <div className="form-group row">
  //                 <div className="col-12">
  //                   <button
  //                     className="btn btn-theam btn-dark btn-lg btn-block ml-3 font-size-12"
  //                     onClick={removeImg}
  //                   >
  //                     Remove Upload
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </ImageUploading>
  //       </div>
  //     );
  //   }
  //   console.log(imageElements);
  //   return imageElements;
  // };

  const removeImg = async () => {
    setAddImage(addImage - 1);
    try {
      const response = await imageService.deleteAllCarouselImages();

      if (response) {
        console.log("All carousel images deleted successfully");
      } else {
        console.error("Failed to delete carousel images");
      }
    } catch (error) {
      console.error("Error deleting carousel images:", error);
    }
  };

  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setAddImage(addImage + 1);
    event.preventDefault();
    event.stopPropagation();
    console.log("I am in onChange event handler");

    const inputElement = event.target;
    if (inputElement && inputElement.files && inputElement.files.length > 0) {
      // Assuming the input field has the 'files' property containing selected files
      const selectedFile = inputElement.files[0];

      if (selectedFile) {
        // Read the selected file as a data URL
        const reader = new FileReader();
        reader.onloadend = async () => {
          // Extract image data from the data URL
          const imgString = (reader.result as string).split("base64,")[1];

          // Get the image type from the file
          const imgType = selectedFile.type.split("/")[1].toLowerCase();

          // Update the imageUploadModel dynamically
          const imageUploadModel = {
            image: imgString,
            imageType: imgType,
          };

          try {
            const { data } = await imageService.saveCarouselImage({
              image: imageUploadModel,
            });

            console.log("data.data", data.data);

            const newElement = produce(element, (draft) => {
              draft.properties.imageUrl = data.data;
            });

            dispatch(startEditElement(newElement));
          } catch (error) {
            console.error("Error saving image:", error);
          }
        };

        // Read the file as a data URL
        reader.readAsDataURL(selectedFile);
      }
    }
  };

  async function fetchAndDisplayCarouselImages() {
    try {
      const carouselImages = await imageService.getCarouselImages();

      if (carouselImages) {
        setImages(carouselImages);
      } else {
        console.error("Failed to fetch carousel images");
      }
    } catch (error) {
      console.error("Error fetching carousel images:", error);
    }
  }

  const numberOfImagesUpload = images?.length;

  return (
    <div className="container">
      <label>Select Images</label>
      {/* {addNewImage(addImage)} */}
      <div key={uuid()} className="col-sm-8">
        <input type="file" accept="image/*" onChange={onChange} />
      </div>

      <div className="form-group col-12 m-2 p-2">
        <h6>
          {numberOfImagesUpload}{" "}
          {numberOfImagesUpload == 1 ? "image" : "images"} have been uploaded
        </h6>
        {/* <button
          disabled={disablePlusButton()}
          type="button"
          className="btn btn-dark btn-sm font-size-12 mr-2"
          onClick={handleAddImageClick}
        >
          <i className="fa fa-plus"></i>
        </button>
        <button
          disabled={disableMinusButton()}
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={handleRemoveImageClick}
        >
          <i className="fa fa-minus"></i>
        </button> */}
      </div>
      <div className="col-12">
        <button
          className="btn btn-theam btn-dark btn-lg btn-block ml-3 font-size-12"
          onClick={removeImg}
        >
          Remove Upload
        </button>
      </div>
    </div>
  );
};

export default CarouselElementProperties;
